import { useCallback, useEffect, useState } from "react";
import useSnackbar from "src/store/useSnackbar";
import useCouponService from "./useCouponService";
const usePodCouponHandler = (props)=>{
    const [selectedProductId, setSelectedProductId] = useState(null);
    const { addSnackbar  } = useSnackbar();
    const couponService = useCouponService({
        orderItems: props.orderItems,
        userCoupons: props.podCoupons,
        allowedProductIds: props.allowedProductIds
    });
    const toggleCoupon = useCallback((itemId, coupon)=>{
        if (coupon === null || couponService.hasCoupon(itemId)) {
            return couponService.removeCoupon(itemId);
        }
        return couponService.applyCoupon(itemId, coupon);
    }, [
        couponService
    ]);
    const applyCouponCheck = useCallback((itemId, coupon)=>{
        if (coupon === null) {
            // 이미 적용된 쿠폰이 없으면 성공으로 처리
            if (!couponService.hasCoupon(itemId)) {
                return true;
            }
            return couponService.removeCoupon(itemId);
        }
        return couponService.applyCoupon(itemId, coupon);
    }, [
        couponService
    ]);
    // 에러 처리를 위한 effect - 새로운 에러만 표시 (타임스탬프 기반)
    const [shownTimestamps, setShownTimestamps] = useState({});
    useEffect(()=>{
        const currentErrors = couponService.errors;
        Object.entries(currentErrors).forEach((param)=>{
            let [itemId, error] = param;
            // 타임스탬프가 다르면 새로운 에러로 인식
            if (error && shownTimestamps[itemId] !== error.timestamp) {
                addSnackbar({
                    message: error.message,
                    variant: "error"
                });
                ;
            }
        });
        // 현재 에러의 타임스탬프로 업데이트
        const newTimestamps = {};
        Object.entries(currentErrors).forEach((param)=>{
            let [itemId, error] = param;
            if (error) {
                newTimestamps[itemId] = error.timestamp;
            }
        });
        setShownTimestamps(newTimestamps);
    }, [
        couponService.errors
    ]);
    return {
        ...couponService,
        toggleCoupon,
        applyCouponCheck,
        checkAvailableCouponList: couponService.getAvailableCoupons,
        // UI 상태
        selectedProductId,
        setSelectedProductId
    };
};
export default usePodCouponHandler;
